import { Provider } from '@angular/core';
import { RotorTypeListService } from 'src/pages/rotor-type-list/rotor-type-list.service';
import { GeneralEventsService } from './general-events.service';
import { MachineService } from './machine/machine.service';
import { EditorsService } from './editors.service';
import { TypeDataService } from './type-data.service';
import { RotorSelectInfoService } from './rotor-select-info.service';
import { ImageRendererService } from 'src/pages/rotor-type-details/steps/tolerances-step/components/image-renderer/image-renderer.service';

export const serviceProviders: Provider[] = [
  MachineService,
  GeneralEventsService,
  RotorTypeListService,
  EditorsService,
  TypeDataService,
  RotorSelectInfoService,
  ImageRendererService,
];
